import { createSlice } from "@reduxjs/toolkit";
import { ignoreListReducers } from "slices/settings/helpers";

const initialState = {
  editMode: false,
  ignoreList: [], // [{term: "", newlyCreated: ""]}
  unchangedIgnoreList: [],
  lastUpdated: "",
  updatedBy: "",
  hasBeenEdited: false,
  locked: false,
  selectedIndex: 0,
};

export const readabilityIgnoreSlice = createSlice({
  name: "readabilityIgnore",
  initialState,
  reducers: {
    setEditMode: ignoreListReducers.setEditMode,
    setEditedList: ignoreListReducers.setEditedList,
    deleteTerm: ignoreListReducers.deleteTerm,
    cancelEdits: ignoreListReducers.cancelEdits,
    setLocked: ignoreListReducers.setLocked,
    setIgnoreList: (state, action) => {
      state.ignoreList = action.payload.whitelist.map((term) => ({
        term,
        newlyCreated: false,
      }));
      state.lastUpdated = action.payload.lastUpdated;
      state.updatedBy = action.payload.updatedBy;
      state.hasBeenEdited = false;
      state.locked = action.payload.locked;
      state.unchangedIgnoreList = [];
    },
    addNewTerm: (state, action) => {
      const index = action.payload;
      const updatedList = [...state.ignoreList];
      updatedList.splice(index + 1, 0, {
        term: "",
        newlyCreated: true,
      });

      state.ignoreList = updatedList;
      state.selectedIndex = index + 1;
    },
  },
});

export const {
  setEditMode,
  setEditedList,
  deleteTerm,
  cancelEdits,
  setLocked,
  setIgnoreList,
  addNewTerm,
} = readabilityIgnoreSlice.actions;

export default readabilityIgnoreSlice.reducer;
